// extracted by mini-css-extract-plugin
export default {"ImageGalleryItem":"ImageGalleryItem_ImageGalleryItem__FDGiG","image":"ImageGalleryItem_image__NRKYb"};